import React, { useState } from "react";
import SidebarMenu from "./SidebarMenu";
import SidebarOptions from "./SidebarOptions";

const Sidebar = () => {
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState("membership");

  const selectAndToggle = (type) => {
    setVisible(true);
    setSelected(type);
  };

  return (
    // <div className="sticky top-0 left-0">
    <>
      <SidebarMenu
        selected={selected}
        setSelected={selectAndToggle}
        setVisible={setVisible}
        visible={visible}
      />
      <SidebarOptions
        visible={visible}
        setVisible={setVisible}
        selected={selected}
      />
    </>
    // </div>
  );
};

export default Sidebar;
